<template>
  <div style="padding: 0 10px">
    <From @search="searchCall" />
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall" :isPagination="query" 
    >
      <div slot="action" slot-scope="record">
        <a @click="detail(record)">详情</a>
      </div>
    </WmsTable>

    <el-dialog title="库存记录" :visible.sync="dialogVisible">
      <dialogTable ref="dialog"></dialogTable>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import From from "@/views/inventoryDetails/assist/components/From";
import dialogTable from "@/views/inventoryDetails/assist/components/dialogTable";
import {
  columns,
  columnsOperationData,
} from "@/views/inventoryDetails/assist/indexData";
import { stockPage } from "@/apis/inventoryDetails";
export default {
  title: "辅料",
  name: "Assist",
  components: {
    WmsTable,
    From,
    dialogTable,
  },
  data() {
    return {
      columns,
      columnsOperationData,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      stockOperationData: [],
      customerShopName: "",
      shopProductSku: "",
      dialogVisible: false,
    };
  },
  methods: {
    searchCall: function (fromData) {
      console.log(fromData)
      this.customerShopName = fromData.customerShopName;
      this.shopProductSku = fromData.shopProductSku;
      this.query.current = 1;
      this.query.total = 0;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    pageChangeCall2() {},
    getDataSource: function (fromData) {
      let params = {
        oemProductClassificationId: 3,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        customerShopName: this.customerShopName || undefined,
        shopProductSku: this.shopProductSku || undefined,
      };
      stockPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    detail(record) {
      this.dialogVisible = true;
      let that = this;
      this.$nextTick((_) => {
        console.log(that.$refs.dialog)
        let shopProductSku = record.record.shopProductSku;
        that.$refs.dialog.query = {
          current: 1,
          pageSize: 10,
          total: 0,
          shopProductSku: shopProductSku,
        };
        that.$refs.dialog.detail()
      });
    },
  },
};
</script>

<style scoped></style>
